import { generateState } from '../builder'

export default {
  categories: [],
  category: {},
  ...generateState('getCategories'),
  ...generateState('getCategory'),
}
